// extracted by mini-css-extract-plugin
export default {"bg":"HubBanner_bg__t9YR6"};